
<template>
  <div>
    <Header></Header>
    <div class="container">
      <div class="left">
        <el-row :gutter="10">
          <el-col :span="8" v-for="(item, index) in playerList" :key="index">
            <el-card :body-style="{ padding: '8px' }" shadow="hover">
              <div style="text-align: left">
                <div style="text-align: left; float: left">
                  <a :href="'/userdetail?uid=' + item.uid" target="_blank">
                    <el-avatar :size="sizeList[1]" :src="circleUrl"></el-avatar>
                  </a>
                </div>
                <div class="userinfo">
                  <div class="u-row">
                    <span class="notimpl">角色名：</span
                    ><span>{{ item.playername }}</span>
                  </div>
                  <div class="u-row">
                    <span class="notimpl">所在区：</span
                    ><span>{{ item.district }}</span>
                  </div>
                  <div class="u-row">
                    <span class="notimpl hurt">伤&nbsp;&nbsp;害：</span
                    ><span class="hurtval">{{ item.hurtvalue }}</span>
                    <span class="hurtval-unit">亿</span>
                  </div>
                </div>
              </div>
              <div>
                <div class="bottom">
                  <router-link :to="'/userdetail?uid=' + item.uid"
                    >详情 ></router-link
                  >
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalNum"
          :page-size="21"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div class="right">
        <div class="notice">
          <h3>公告</h3>
          <div>
            尊敬的DNF用户：为了给各位勇士带来更优质的游戏体验，进一步加强游戏的安全性，我们将于4月15日(周四)05:00
            09:00对所有大区进行停机维护，整个维护过程预计需要4小时，因开机顺序以及数据维护内容差异，部分大区会提前开放。因停机给大家带来的不便，我们深表歉意。停机时间：4月15日(周四)05:00
            - 09:00更新大区：所有大区
          </div>
        </div>
        <div class="strategy">
          <h3>攻略</h3>
          <div>
            <el-row>
              <el-col :span="24" v-for="o in 10" :key="o">
                <a href="/article">红眼如何打万亿</a>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "./footer";
import Header from "./headernew";
export default {
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      totalNum: 0,
      playerList: [],
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
    };
  },
  mounted() {
    this.getTotalNum();
    this.getList(1);
  },
  methods: {
    getTotalNum() {
      this.$http
        .get("/api/player")
        .then((r) => {
          this.totalNum = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getList(pageIndex) {
      this.$http
        .get("/api/player/" + pageIndex)
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.playerList = r.data.data;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleCurrentChange(pageIndex) {
      this.getList(pageIndex);
    },
  },
};
</script>

<style scoped>
.container {
  width: 980px;
  margin: 0 auto;
  padding: 16px;
  margin-bottom: 32px;
  font-size: 14px;
}
.left {
  float: left;
  width: 70%;
  box-shadow: 0 0 0 #c7c5c5;
  border: 1px solid #e7e7e7;
  background-color: white;
  padding: 16px;
  text-align: center;
}
.right {
  float: right;
  width: 25%;
}
.u-row{padding:3px;}
.notimpl {
  color: #999;
  font-size: 13px;
}
.hurt {
  width: 52px;
  text-align: right;
  display: inline-block;
}
.hurtval {
  color: lightseagreen;
  font-size: 18px;
}
.hurtval-unit {
  vertical-align: 1px;
  margin-left: 2px;
}
.notice {
  box-shadow: 0 0 0 #c7c5c5;
  border: 1px solid #e7e7e7;
  background-color: white;
  padding: 16px;
  font-size: 15px;
}
.strategy {
  box-shadow: 0 0 0 #c7c5c5;
  border: 1px solid #e7e7e7;
  background-color: white;
  padding: 16px;
  margin-top: 16px;
  font-size: 15px;
}
.h-left {
  float: right;
}
.avatar {
  float: left;
}
.el-col {
  margin-bottom: 8px;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  align-items: center;
}

.button {
  padding: 0;
  min-height: auto;
}

.image {
  width: 10%;
  float: left;
}
.userinfo {
  display: inline-block;
  margin-left: 20px;
}
</style>
